import * as BABYLON from "babylonjs";
export function genPingtaiMat(scene) {
  let mat = new BABYLON.PBRMaterial("pingtaiMat", scene);
  mat.metallic = 0;
  mat.roughness = 1;
  // mat.disableLighting = true
  mat.subSurface.isTranslucencyEnabled = true;
  mat.albedoColor = new BABYLON.Color3(1,1,1)
  
  mat.albedoTexture = new BABYLON.Texture("/static/webgl/pingtai.jpg");
  mat.albedoTexture.hasAlpha = true;
  mat.emissiveColor = new BABYLON.Color3(120/255,120/255,120/255)
  return mat;
}



// WEBPACK FOOTER //
// ./src/components/webgl/LevelsShow/Mats/PingtaiMat.js